
import {
  Typography,
  Grid, Box, makeStyles
} from '@material-ui/core';
import { observer } from "mobx-react";
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';
import { PeopleCriteriaComponentSelection } from '../PeopleCriteriaComponentSelection';
import { Button, SelectField } from '@roc/ui';
import { businessUnitOptions } from '../../leadsDashboard/allLeadDashboard';


const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(5),
  },
}));


export const AddContactsToCadenceModal = observer(({ handleCloseModal, disable }) => {
  const { salesforceLeadStore, cadenceStore } = useStore();
  const { leadsDashboardStore } = salesforceLeadStore
  const classes = useStyles();


  useEffect(() => {
    cadenceStore.fetchDashboards();
  }, []);

  const handleSubmission = async () => {
    cadenceStore.cadenceUsersDashboardGridStore.reset();
    cadenceStore.goNextStep();
  };


  return (
    <Grid item container>
      <Grid item xs={12}>
        <Typography variant="h6">Select Business Unit</Typography>
      </Grid>
      <Grid item xs={12}>
        <SelectField
          value={cadenceStore.gridBusinessUnit}
          options={businessUnitOptions}
          onChange={value => {
            cadenceStore.gridBusinessUnit = value
          }}
          fullWidth
          variant={'outlined'}
          testId={'businessUnit'}
          style={{ height: '30px' }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Select set of prospects from dropdown</Typography>
      </Grid>
      {cadenceStore.allDashboards.length > 0 &&
        <Grid item xs={12}>
          <PeopleCriteriaComponentSelection disable={disable} />
        </Grid>
      }
      <Grid container spacing={2} justifyContent="flex-end" className={classes.buttonContainer}>
        <Grid item xs={2}>
          <Button
            onClick={handleCloseModal}
            color="primary"
            variant="outlined"
            testId="cancel"
            fullWidth
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmission}
            testId="next"
            fullWidth
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});